var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields}})}
var staticRenderFns = []

export { render, staticRenderFns }